import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Department } from '~/app/open-age/directory/models';
import { DepartmentService } from '~/app/open-age/directory/services';

@Component({
  selector: 'directory-department-picker',
  templateUrl: './department-picker.component.html',
  styleUrls: ['./department-picker.component.css']
})
export class DepartmentPickerComponent implements OnInit, OnChanges {

  @Input()
  department: Department;

  @Input()
  readonly = false;

  @Input()
  required = false;

  @Input()
  placeholder: string;

  @Input()
  reset = false;

  @Input()
  usercode: string;

  @Output()
  changed: EventEmitter<Department> = new EventEmitter();

  @ViewChild('userInput')
  userInput: ElementRef<HTMLInputElement>;

  @ViewChild('departmentPicker')
  matAutocomplete: MatAutocomplete;

  control = new FormControl();

  isEditing = false;

  items: Department[];

  constructor(
    private api: DepartmentService
  ) {

    this.control.valueChanges.pipe(
      debounceTime(300),
      switchMap((value) => this.api.search({ name: value }))
    ).subscribe((page) => {
      this.items = page.items;
    });
  }

  ngOnInit() {
    this.userInput.nativeElement.value = this.display(this.department);
  }

  ngOnChanges() {
    if (this.usercode === 'my') {
      this.readonly = true;
      this.required = false;
    }
    if (this.reset) {
      this.department = null;
    }
  }

  display(department?: Department): string | undefined {
    if (!department) {
      return '';
    }

    if (typeof department === 'string') {
      return department;
    }

    if (!department.name || !department.name) {
      return department.code;
    }

    return `${department.name}`;
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.department = event.option.value;

    this.changed.emit(this.department);

    this.userInput.nativeElement.value = this.display(this.department);
    this.control.setValue(null);
  }
}
